__turbopack_context__.v({
  "className": "satoshi_a5d2cc61-module__N0v_zW__className",
});
